import React from 'react';
import { connect } from 'react-redux';
import { OnboardingNavbar } from '../OnboardingNavbar/OnboardingNavbar';
import { OnboardingProgress } from '../OnboardingProgress/OnboardingProgress';
import { updateConfigOnboardingSettings } from '../../../redux/config/slice';
import { selectConfig, selectUpdateConfigLoading } from '../../../redux/config/selectors';
import { OnboardingActions } from '../OnboardingActions/OnboardingActions';
import {
  OnboardingHeaderGroup,
  OnboardingContent,
  OnboardingContentGroup,
  OnboardingContentTitle,
  OnboardingStepWrapper,
  OnboardingContentGroupText,
  OnboardingContentInfo,
  OnboardingPortalInfo,
  OnboardingPortalInfoTitle,
  OnboardingPortalInfoContent,
  OnboardingPortalInfoText
} from '../../ui/Layout/OnboardingLayout';
import { ONBOARDING_STEPS } from '../../../consts/consts';
import { CopyButton } from '../../ui';
import { Heading2 } from '../../ui/Typography/Heading';

export const OnboardingStepOrganizationSuccessComponent = ({
  updateConfigOnboardingSettings,
  config,
  updateConfigLoading
}) => {
  const portalDomain = config?.oqio_portal_domain || '';
  const portalEmail = config?.oqio_portal_email || '';

  const handleOnBack = () => {
    updateConfigOnboardingSettings({ step: ONBOARDING_STEPS.DOCUMENTS });
  };

  const handleOnNext = () => {
    updateConfigOnboardingSettings({ step: ONBOARDING_STEPS.OVERVIEW_HOUSING_STOCK });
  };

  return (
    <>
      <OnboardingNavbar loading={updateConfigLoading} />
      <OnboardingProgress />
      <OnboardingContent>
        <OnboardingStepWrapper>
          <OnboardingHeaderGroup>
            <OnboardingContentTitle>
              <Heading2>Ihr Unternehmen ist jetzt angelegt</Heading2>
            </OnboardingContentTitle>
            <OnboardingContentInfo>
              <OnboardingContentGroupText>
                Die grundlegende Einrichtung Ihres Versicherungsportals wurde erfolgreich abgeschlossen. Alle soeben
                festgelegten Einstellungen können Sie jederzeit in der Verwaltung einsehen und bei Bedarf anpassen.
              </OnboardingContentGroupText>
              <OnboardingContentGroupText>
                Im nächsten Schritt der Einführung können Sie einen Bestand anlegen, alle relevanten Unternehmen, mit
                denen Sie zusammenarbeiten, hinzufügen und Ihre Stammdaten importieren.
              </OnboardingContentGroupText>
            </OnboardingContentInfo>
          </OnboardingHeaderGroup>

          <OnboardingContentGroup className="step-outro footer">
            <OnboardingPortalInfo>
              <OnboardingPortalInfoTitle>Ihre Domain</OnboardingPortalInfoTitle>
              <OnboardingPortalInfoContent>
                <OnboardingPortalInfoText>{portalDomain}</OnboardingPortalInfoText>
                <CopyButton ariaLabel="Domain kopieren" successMessage="Domain wurde kopiert" value={portalDomain} />
              </OnboardingPortalInfoContent>
            </OnboardingPortalInfo>

            <OnboardingPortalInfo>
              <OnboardingPortalInfoTitle>Ihre Portal-Mail-Adresse</OnboardingPortalInfoTitle>
              <OnboardingPortalInfoContent>
                <OnboardingPortalInfoText>{portalEmail}</OnboardingPortalInfoText>
                <CopyButton
                  ariaLabel="Portal-Mail-Adresse kopieren"
                  successMessage="Portal-Mail-Adresse wurde kopiert"
                  value={portalEmail}
                />
              </OnboardingPortalInfoContent>
            </OnboardingPortalInfo>
          </OnboardingContentGroup>
        </OnboardingStepWrapper>

        <OnboardingActions
          onBack={handleOnBack}
          onNext={handleOnNext}
          nextIcon={false}
          loading={updateConfigLoading}
          nextLabel="Zum nächsten Schritt"
        />
      </OnboardingContent>
    </>
  );
};

const mapStateToProps = (state) => ({
  config: selectConfig(state),
  updateConfigLoading: selectUpdateConfigLoading(state)
});

const mapDispatchToProps = {
  updateConfigOnboardingSettings
};

export const OnboardingStepOrganizationSuccess = connect(
  mapStateToProps,
  mapDispatchToProps
)(OnboardingStepOrganizationSuccessComponent);
